import { useContext } from "react";
import { Box, Stack, Typography, Grid } from "@mui/material";
import { useLocation } from "react-router-dom";
import moment from "moment";
//Import from project
import "./studentdetail.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import MaleIcon from "@mui/icons-material/Male";
import EmailIcon from "@mui/icons-material/Email";
import FemaleIcon from "@mui/icons-material/Female";
import EmptyImage from "../../Assets/empty-image.png";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import useGetTeacherById from "../../Hooks/useGetTeacherById";

export const TeacherCard = ({studentData}) => {
  // Change Language
  const { language, t } = useContext(AuthContext);


  return (
    <Box className="card-detail">
      <Stack direction="column" spacing={1.5}>
        <Grid container rowSpacing={1.5}>
          <Grid item xs={12} sm={4} md={4} lg={12} xl={12}>
            <Stack direction="column" justifyContent="center" spacing={1}>
              <Stack direction="row" justifyContent="center">
                <img
                  style={{
                    maxWidth: "160px",
                    maxHeight: "180px",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                  src={studentData?.profile ? studentData?.profile : EmptyImage}
                  alt="green iguana"
                />
              </Stack>
              <Typography className={t("class-name-title-big")}>
                {studentData?.familyName || ""} {studentData?.userName || ""}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={8} md={8} lg={12} xl={12}>
            <Stack direction="column" spacing={1.2} justifyContent="center">
              <Stack
                direction="row"
                spacing={1.2}
                className={t("class-name-title")}
              >
                {studentData?.gender === "Male" ? (
                  <MaleIcon className="icon" />
                ) : (
                  <FemaleIcon className="icon" />
                )}

                <Typography>
                  {studentData?.gender
                    ? studentData?.gender === "Male"
                      ? t("thead_male")
                      : t("thead_female")
                    : "--:--"}
                </Typography>
              </Stack>

              <Stack
                direction="row"
                spacing={1.2}
                className={t("class-name-title")}
              >
                <DateRangeIcon className="icon" />
                <Typography>
                  {studentData?.dob
                    ? moment(studentData?.dob).format("DD MMM YYYY")
                    : "--:--"}
                </Typography>
              </Stack>

              {/* <Stack
                direction="row"
                spacing={1.2}
                className={t("class-name-title")}
              >
                <AutorenewIcon className="icon" />
                <Typography>Is studying</Typography>
              </Stack> */}

              <Stack
                direction="row"
                spacing={1.2}
                className={t("class-name-title")}
              >
                <MailOutlineIcon className="icon" />
                <Typography> {studentData?.email || "--:--"}</Typography>
              </Stack>

              <Stack
                direction="row"
                spacing={1.2}
                className={t("class-name-title")}
              >
                <LocalPhoneIcon className="icon" />
                <Typography> {studentData?.phoneNumber || "--:--"}</Typography>
              </Stack>
              <Stack
                direction="row"
                spacing={1.2}
                className={t("class-name-title")}
              >
                <FmdGoodIcon className="icon" />
                <Typography>{studentData?.address || "--:--"}</Typography>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};
